import Lenis from '@studio-freight/lenis'

export class SmoothScroll {
  constructor() {
    this.lenis = new Lenis({
      syncTouch: true,
    })
    const raf = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)
  }
}
